export const config = { 
    wpApi: "/wp-json/wp/v2/",
    vasApi: "/wp-json/vas",
  };
